export interface TicketStatusOption {
  text: string;
  icon: string;
  value: string;
}

export const ticketStatusEnum: Record<string, TicketStatusOption> = {
  BACKLOG: {
    text: "Backlog",
    icon: "seem-icon-jira-icon-backlog",
    value: "BACKLOG",
  },
  SCHEDULED: {
    text: "Scheduled",
    icon: "seem-icon-schedule",
    value: "SCHEDULED",
  },
  IN_PROGRESS: {
    text: "In Progress",
    icon: "seem-icon-jira-icon-in-progress",
    value: "IN_PROGRESS",
  },
  DONE: {
    text: "Done",
    icon: "seem-icon-jira-icon-done",
    value: "DONE",
  },
  DELETED: {
    text: "Deleted",
    icon: "seem-icon-bin",
    value: "DELETED",
  },
  REJECTED: {
    text: "Rejected",
    icon: "seem-icon-close",
    value: "REJECTED",
  },
};
